// import { Button} from '@blueprintjs/core';
import './App.css';

// Hooks
import { useSelector } from "react-redux"
import { RefApplicationParameterHook, useCheckServer, useInitializeApp, useIsMobile, useOperationalContext } from './components/hooks/ApplicationParametersHooks';
import { RefCurrentPage } from './components/hooks/NavegationHook';
import { IsStaff, RefSurrogateUser } from './components/hooks/AuthenticationHook';

// Selectors
import { selectIsAppReady } from './store/selectors/applicationSelectors';


import MobileLoginPage from './pagesMobile/MobileLoginPage';
import LoginPage from './pages/LoginPage';
import MobileNav from './components/navegation/MobileNav';
import Nav from './components/navegation/Nav';
import CustomTickerTape from './components/tradingViewComponentes/CustomTickerTape';
import * as con from "./GlobalConstants"

import { ToastContainer } from 'react-toastify';
import COPAlertModal from './components/alerts/COPAlert';
import UnsavedModelParametersModal from './components/navegation/UnsavedModelParametersModal';
import { DesktopPageRenderer, MobilePageRenderer } from './components/navegation/PagesRender';


function App() {

  useCheckServer();
  const appReady = useSelector(selectIsAppReady)
  const isStaff = IsStaff()
  const surrogateUser = RefSurrogateUser()
  const isMobile = useIsMobile()
  const currentPage = RefCurrentPage();
  const selectedUserLine = RefApplicationParameterHook(con.SELECTED_LINE)
  useInitializeApp(appReady, isStaff)
  useOperationalContext(appReady, isStaff, surrogateUser, selectedUserLine)

  
  return (
    <div className="App bp3-dark">
      <COPAlertModal/> 
      <UnsavedModelParametersModal />
      {
        !appReady
          ? (isMobile ? <MobileLoginPage /> : <LoginPage />)
          : (
            isMobile
              ? <div>
                  <MobileNav />
                  <div style={{ height: `${con.MOBILE_NAV_BAR}vh` }}></div>
                   <div className="mainPageWrapper"><MobilePageRenderer page={currentPage} /></div>
                </div>
              : <div>
                  <Nav />
                  <div style={{ height: `${con.NAV_BAR}vh` }}></div>
                  <CustomTickerTape />

                  <div className="mainPageWrapper"><DesktopPageRenderer page={currentPage} /></div>
                </div>
          )
      }
      <ToastContainer
        position="bottom-center"
        autoClose={4000}
        newestOnTop
        closeOnClick
        draggable
      />
    </div>
    
  );
}

export default App;
